/**
 * Unified Grind Selector for Bundle Products
 * Provides a single grind selector that controls multiple product grind options
 */

(function () {
  // Get section ID from the script tag or use default
  const scriptTag = document.currentScript;
  const sectionId = scriptTag?.dataset.sectionId || 'template--15837036150842__main';
  
  const unifiedSelector = document.getElementById(`unified-grind-${sectionId}`);
  const unifiedContainer = document.getElementById(`unified-grind-selector-${sectionId}`);

  if (!unifiedSelector || !unifiedContainer) return;

  /**
   * Get product data
   */
  function getProductData() {
    const productJson = document.getElementById(`ProductJson-${sectionId}`);
    if (!productJson) return null;
    try {
      return JSON.parse(productJson.textContent);
    } catch (e) {
      console.error('Failed to parse product JSON:', e);
      return null;
    }
  }

  /**
   * Check if a variant with specific options exists
   */
  function variantExists(productData, options) {
    if (!productData || !productData.variants) return false;

    return productData.variants.some((variant) => {
      return options.every((optionValue, index) => {
        const variantOption = variant[`option${index + 1}`];
        return variantOption === optionValue;
      });
    });
  }

  /**
   * Initialize unified grind selector for bundle products
   */
  function initUnifiedGrindSelector() {
    const productData = getProductData();
    
    // Find all grind selectors
    const allSelects = document.querySelectorAll('.variant-selects select.select__select');
    const grindSelects = Array.from(allSelects).filter((select) => {
      const name = select.getAttribute('name') || '';
      return name.toLowerCase().includes('grind');
    });

    // Only show unified selector if there are 2+ grind options
    if (grindSelects.length < 2) return;

    console.log(`Found ${grindSelects.length} grind selectors, enabling unified selector`);

    // Collect all unique grind options across all selects
    const allOptions = new Set();
    const optionAvailability = {};

    grindSelects.forEach((select, selectIndex) => {
      const options = Array.from(select.options);
      options.forEach((option) => {
        const value = option.value;
        if (value) {
          allOptions.add(value);
          if (!optionAvailability[value]) {
            optionAvailability[value] = [];
          }
          optionAvailability[value].push(selectIndex);
        }
      });
    });

    // Populate unified selector with common options
    unifiedSelector.innerHTML = '<option value="">Select Grind Type</option>';

    allOptions.forEach((optionValue) => {
      const option = document.createElement('option');
      option.value = optionValue;
      option.textContent = optionValue;

      // Mark if not available in all products
      const availableCount = optionAvailability[optionValue].length;
      if (availableCount < grindSelects.length) {
        option.textContent += ` (${availableCount}/${grindSelects.length} products)`;
      }

      unifiedSelector.appendChild(option);
    });

    // Set initial value from first grind selector
    if (grindSelects[0].value) {
      unifiedSelector.value = grindSelects[0].value;
    }

    // Show unified selector
    unifiedContainer.style.display = 'inline-flex';

    // Hide individual grind selectors
    grindSelects.forEach((select) => {
      const container = select.closest('.product-form__input');
      if (container) {
        container.style.display = 'none';
      }
    });

    // Listen for changes on unified selector
    unifiedSelector.addEventListener('change', function () {
      const selectedValue = this.value;
      if (!selectedValue) return;

      console.log('Unified grind changed to:', selectedValue);

      // Build the proposed option combination
      const allSelects = document.querySelectorAll('.variant-selects select.select__select');
      const proposedOptions = Array.from(allSelects).map((select) => {
        const name = select.getAttribute('name') || '';
        if (name.toLowerCase().includes('grind')) {
          return selectedValue;
        }
        return select.value;
      });

      console.log('Proposed options:', proposedOptions);

      // Check if this variant combination exists
      if (productData && !variantExists(productData, proposedOptions)) {
        console.warn('Variant combination does not exist:', proposedOptions);
        alert(
          `The combination with all "${selectedValue}" grind type is not available for this bundle. Please select items individually.`
        );
        
        // Revert to previous value
        const firstGrindValue = grindSelects[0]?.value;
        if (firstGrindValue) {
          unifiedSelector.value = firstGrindValue;
        }
        return;
      }

      // Update all individual selectors sequentially with delays
      let delay = 0;

      grindSelects.forEach((select, index) => {
        setTimeout(() => {
          const hasOption = Array.from(select.options).some((opt) => opt.value === selectedValue);

          if (hasOption) {
            if (select.value !== selectedValue) {
              console.log(`Updating selector ${index} to:`, selectedValue);
              select.value = selectedValue;

              // Trigger change event to update Shopify's variant system
              const event = new Event('change', { bubbles: true });
              select.dispatchEvent(event);
            }
          } else {
            console.warn(`Grind option "${selectedValue}" not available for product ${index}`);
          }
        }, delay);

        // Add 100ms delay between each selector update
        delay += 100;
      });
    });

    // Listen for changes on individual selectors
    grindSelects.forEach((select) => {
      select.addEventListener('change', function () {
        // Sync back to unified selector if all have same value
        const values = grindSelects.map((s) => s.value);
        const allSame = values.every((v) => v === values[0]);
        if (allSame && values[0]) {
          unifiedSelector.value = values[0];
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUnifiedGrindSelector);
  } else {
    initUnifiedGrindSelector();
  }

  // Re-initialize if variant system updates
  document.addEventListener('variant:change', initUnifiedGrindSelector);
})();

